import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import telecommunications from '../../../assets/telecommunications.png';
import logoGuentic from '../../../assets/logoGuentic.png';
import logonew2 from '../../../assets/logonew2.webp';
import { Loader } from "../../../Loader/Loader";
import { domain } from '../../../Urls/Services/Api_urls';
import Swal from "sweetalert2";
import Navbar from '../../../Gerneralcomponents/Navbar/Navbar';
import Footer from '../../../Gerneralcomponents/Footer/footer';
import './ConfirmAddNewService.css';
export default function ConfirmacionCorreo() {
	const location = useLocation();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [name, setName] = useState('');
	const [token, setToken] = useState('');
	const ctaRef = useRef(null);

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		setToken(params.get('token') || '');
		setName(params.get('name') || 'Usuario');
	}, [location.search]);

	useEffect(() => {
		ctaRef.current?.focus();
	}, []);

	const handleConfirmar = async () => {
		setLoading(true);
		try {
			const response = await fetch(`${domain}/post2venta/post_request/create/`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ token }),
			});
			if (response.ok) {
				setLoading(false);
				await Swal.fire({
					title: `¡Solicitud confirmada, ${name || 'Usuario'}!`,
					text: "Serás redirigido a la página de inicio.",
					icon: "success",
					confirmButtonText: "Ir al inicio",
					allowOutsideClick: false,
				});

				navigate('/login');
			} else {
				throw new Error('Error en la solicitud');
			}
		} catch (err) {
			setLoading(false);
			await Swal.fire({
				title: "Error al confirmar",
				text: "Intenta nuevamente.",
				icon: "error",
				confirmButtonText: "Aceptar",
				allowOutsideClick: false,
			});
			navigate('/login');
		}
	};

	return (
		<>
		<Navbar />
		<div className="confirm-add-service-wrapper">
		{/* Loader bloqueante */}
		{loading && (
			<div style={{
			position:'fixed', inset:0, background:'rgba(255,255,255,0.7)',
			zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center'
			}}>
			<Loader />
			<span aria-live="polite" style={{position:'absolute', top:-9999, left:-9999}}>Procesando solicitud…</span>
			</div>
		)}

		<main className="page" role="main" aria-label="Confirmación de asociación de servicio">
			{/* Izquierda: hero estable (imagen desde import) */}
			<section
				className="hero"
				aria-hidden="true"
				style={{
					backgroundImage: `linear-gradient(120deg, rgba(16,14,32,.65), rgba(9,12,26,.15)), url(${telecommunications})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					backgroundRepeat: 'no-repeat',
				}}
			/>

			{/* Derecha: panel de acción */}
			<section className="panel">
				<div className="panel-card">
					<img src={logonew2} alt="Logo EMCALI" className="brand" />
					<h2 className="title-greeting">¡Hola, {name}!</h2>
					<p className="lead">
						Tu asociación de servicio contratado a tu cuenta está lista.<br />
						Haz clic en <b>"Aceptar"</b> para confirmar tu solicitud.
					</p>
					<button
						ref={ctaRef}
						className="cta"
						onClick={handleConfirmar}
						disabled={loading}
						aria-busy={loading ? 'true' : 'false'}
						aria-label="Aceptar y confirmar la solicitud"
					>
						Aceptar
					</button>
				</div>

				{/* Ícono / marca esquina; se oculta en móvil */}
				<img src={logoGuentic} alt="Guentic" className="corner" />
			</section>
		</main>
		<Footer />
		</div>
		</>
	);
}
